import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { X, Check, Brain, Database, MessageCircle, Bot, LineChart } from 'lucide-react';
export function MaquinaAdministrativa() {
  const comparisons = [{
    task: 'Saber cuánto ganás',
    without: 'Intuición',
    with: 'Dashboard financiero'
  }, {
    task: 'Confirmar turnos',
    without: 'WhatsApp manual',
    with: 'Señas automáticas'
  }, {
    task: 'Recordar cada clienta',
    without: 'Memoria',
    with: 'Fichas en Notion'
  }, {
    task: 'Delegar o escalar',
    without: 'Todo en tu cabeza',
    with: 'Manual de operaciones'
  }, {
    task: 'Tomar vacaciones',
    without: 'El negocio para',
    with: 'Sistemas automáticos'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-5xl mx-auto" data-id="element-210">
      <FadeIn data-id="element-211">
        <div className="text-center mb-6 md:mb-12" data-id="element-212">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 rounded-full bg-[#c9a961]/10 mb-3 md:mb-6 border border-[#c9a961]/20 relative" data-id="element-213">
            <div className="absolute inset-0 bg-[#c9a961]/20 blur-xl rounded-full animate-pulse" data-id="element-214"></div>
            <Brain className="text-[#b8860b] relative z-10 w-7 h-7 md:w-10 md:h-10" data-id="element-215" />
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-[#1a1611] mb-2 md:mb-4 px-2" data-id="element-216">
            ¿QUÉ AGREGA LA MÁQUINA ADMINISTRATIVA IA?
          </h2>
          <p className="text-sm md:text-xl text-[#6b5d4f] font-bold max-w-2xl mx-auto" data-id="element-217">
            El sistema para que tu negocio funcione sin vos.
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-6 md:mb-12" data-id="element-218">
        <FadeIn delay={0.2} data-id="element-219">
          <div className="bg-[#b91c1c]/5 border border-[#b91c1c]/20 rounded-2xl p-4 md:p-8 h-full" data-id="element-220">
            <div className="flex items-center gap-3 mb-4 md:mb-8 pb-3 md:pb-4 border-b border-[#b91c1c]/10" data-id="element-221">
              <div className="bg-[#b91c1c]/10 p-1.5 md:p-2 rounded-lg" data-id="element-222">
                <X className="text-[#b91c1c] w-5 h-5 md:w-6 md:h-6" data-id="element-223" />
              </div>
              <h3 className="text-base md:text-xl font-black text-[#b91c1c]" data-id="element-224">
                Sin Máquina Administrativa
              </h3>
            </div>
            <div className="space-y-3 md:space-y-6" data-id="element-225">
              {comparisons.map((item, i) => <div key={i} className="flex flex-col gap-0.5 md:gap-1" data-id="element-226">
                  <span className="text-xs md:text-sm text-[#6b5d4f] font-bold" data-id="element-227">
                    {item.task}
                  </span>
                  <span className="text-base md:text-lg font-mono text-[#1a1611] font-medium" data-id="element-228">
                    {item.without}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-229">
          <div className="bg-white border-2 border-[#c9a961]/50 rounded-2xl p-4 md:p-8 h-full relative overflow-hidden shadow-[0_10px_30px_rgba(201,169,97,0.1)]" data-id="element-230">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#c9a961]/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-231"></div>

            <div className="flex items-center gap-3 mb-4 md:mb-8 pb-3 md:pb-4 border-b border-[#c9a961]/20 relative z-10" data-id="element-232">
              <div className="bg-[#c9a961] p-1.5 md:p-2 rounded-lg shadow-[0_0_15px_rgba(201,169,97,0.5)]" data-id="element-233">
                <Check className="text-[#0a0a0a]" w-5 h-5 md:w-6 md:h-6 strokeWidth={3} data-id="element-234" />
              </div>
              <h3 className="text-base md:text-xl font-black text-[#b8860b]" data-id="element-235">
                Con Máquina Administrativa
              </h3>
            </div>
            <div className="space-y-3 md:space-y-6 relative z-10" data-id="element-236">
              {comparisons.map((item, i) => <div key={i} className="flex flex-col gap-0.5 md:gap-1" data-id="element-237">
                  <span className="text-xs md:text-sm text-[#6b5d4f] font-bold" data-id="element-238">
                    {item.task}
                  </span>
                  <span className="text-sm md:text-lg font-mono font-black text-[#0a0a0a] bg-[#c9a961]/20 w-fit px-2 md:px-3 py-0.5 md:py-1 rounded-md border border-[#c9a961]/30" data-id="element-239">
                    {item.with}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>

      <FadeIn delay={0.4} data-id="element-240">
        <div className="flex flex-wrap justify-center gap-2 md:gap-6" data-id="element-241">
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e8dfd0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#1a1611] shadow-sm" data-id="element-242">
            <Database size={14} className="text-[#c9a961]" data-id="element-243" /> Notion
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e8dfd0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#1a1611] shadow-sm" data-id="element-244">
            <MessageCircle size={14} className="text-[#c9a961]" data-id="element-245" /> WhatsApp
            Business
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e8dfd0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#1a1611] shadow-sm" data-id="element-246">
            <Bot size={14} className="text-[#c9a961]" data-id="element-247" /> ChatGPT
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e8dfd0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#1a1611] shadow-sm" data-id="element-248">
            <LineChart size={14} className="text-[#c9a961]" data-id="element-249" /> Finanzas
          </div>
        </div>
        <p className="text-center text-sm md:text-base text-[#b8860b] font-black mt-3 md:mt-6" data-id="element-250">
          Implementación en 30 días incluida
        </p>
      </FadeIn>
    </section>;
}